import { FC } from 'react';
import { BackendClient } from '@/infrastructure/clients/BackendClient';
import LureoButton from '@/common/LureoButton';
// Google's own mark in Google's own colours, which no theme changes
import googleG from '@/assets/google-g.svg';

interface GoogleAuthButtonProps {
  onError: (message: string) => void;
  marketingConsent?: boolean;
  canStart?: () => boolean;
}

export const GoogleAuthButton: FC<GoogleAuthButtonProps> = ({ onError, marketingConsent, canStart }) => {

  const handleGoogleSignIn = async () => {
    if (canStart && !canStart()) return;
    try {
      // Always use current origin as redirect URL - this ensures it matches the current environment
      // Supabase will validate this against the allowed redirect URLs in the project settings
      const redirectUrl = window.location.origin;

      const { data, error } = await BackendClient.auth.signInWithOAuth({
        provider: 'google',
        marketingConsent,
        options: {
          redirectTo: redirectUrl,
          queryParams: {
            access_type: 'offline',
            prompt: 'consent',
          }
        }
      });
      
      if (error) {
        onError(error.message);
        return;
      }

      if (data.url) {
        // Redirect to Google's OAuth page
        window.location.href = data.url;
      }
    } catch {
      onError('Failed to connect to Google authentication');
    }
  };

  return (
    <LureoButton
      onClick={handleGoogleSignIn}
      variant="outline-3"
      className="w-full h-9 rounded-lureo-radius-button-pill"
    >
      <span className="flex items-center justify-center gap-2">
        <img src={googleG} alt="" aria-hidden className="h-5 w-5" />
        Continue with Google
      </span>
    </LureoButton>
  );
}; 